import React, { useState, useEffect } from 'react';
import { Input } from './ui/input';
import { frenchPostalCodes } from '../data/mock';

const PostalCodeInput = ({ value, onChange, onCitySelect }) => {
  const [postalCode, setPostalCode] = useState('');
  const [matchingCities, setMatchingCities] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [selectedCity, setSelectedCity] = useState(value || '');

  // Filtrer les villes selon le code postal saisi
  useEffect(() => {
    if (postalCode.length >= 2) {
      const matches = frenchPostalCodes.filter(item => 
        item.postalCode.startsWith(postalCode)
      );
      setMatchingCities(matches);
      setShowSuggestions(matches.length > 0);
    } else {
      setMatchingCities([]);
      setShowSuggestions(false);
    }
  }, [postalCode]);

  const handlePostalCodeChange = (e) => {
    const input = e.target.value;
    // Autoriser uniquement les chiffres et limiter à 5 caractères
    if (/^\d{0,5}$/.test(input)) {
      setPostalCode(input);
      setSelectedCity(''); // Réinitialiser la ville sélectionnée
      if (onChange) onChange(''); // Informer le parent
    }
  };

  const handleCitySelect = (city, postal) => {
    const fullLocation = `${postal} - ${city}`;
    setSelectedCity(fullLocation);
    setShowSuggestions(false);
    if (onCitySelect) onCitySelect(fullLocation);
    if (onChange) onChange(fullLocation);
  };

  return (
    <div className="relative">
      {/* Affichage de la ville sélectionnée OU du champ de saisie */}
      {selectedCity ? (
        <div className="flex items-center justify-between bg-[#020d2a] border border-gray-700 rounded-md px-3 py-2 text-white">
          <span>{selectedCity}</span>
          <button
            type="button"
            onClick={() => {
              setSelectedCity('');
              setPostalCode('');
              if (onChange) onChange('');
            }}
            className="text-orange-500 hover:text-orange-400 ml-2 font-semibold"
          >
            ✕
          </button>
        </div>
      ) : (
        <Input
          type="text"
          value={postalCode}
          onChange={handlePostalCodeChange}
          placeholder="Code postal (ex: 75001)"
          className="w-full bg-#020d2a border-gray-700 text-white placeholder:text-gray-400"
          maxLength={5}
        />
      )}

      {/* Liste des suggestions */}
      {showSuggestions && !selectedCity && (
        <div className="absolute z-50 w-full mt-1 bg-[#020d2a] border border-gray-700 rounded-md shadow-lg max-h-60 overflow-y-auto">
          {matchingCities.map((item, index) => (
            <button
              key={index}
              type="button"
              onClick={() => handleCitySelect(item.city, item.postalCode)}
              className="w-full text-left px-4 py-2 hover:bg-#020d2a text-white border-b border-gray-700 last:border-b-0"
            >
              <span className="font-semibold text-orange-400">{item.postalCode}</span>
              {' - '}
              <span>{item.city}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default PostalCodeInput;
